import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entityPersonasFisicaAdapter, EntityPersonasFisicaState } from './entity-personas-fisica.state';

const { selectEntities, selectAll } =
  entityPersonasFisicaAdapter.getSelectors();

export const getError = (state: EntityPersonasFisicaState): any => state.error;

export const getIsLoading = (state: EntityPersonasFisicaState): boolean =>
  state.isLoading;

export const selectPersonasFisicaState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.personasFisica
);

export const selectAllPersonasFisica = createSelector(
  selectPersonasFisicaState,
  selectAll
);
export const selectEntitiesPersonasFisica = createSelector(
  selectPersonasFisicaState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectPersonasFisicaError = createSelector(
  selectPersonasFisicaState,
  getError
);

// MemoizedSelector<object,any>
export const selectPersonasFisicaIsLoading = createSelector(
  selectPersonasFisicaState,
  getIsLoading
);
